export class DamageReport {
    id: number;
    date_submitted: string; 
    time_submitted: string;
    time_string: TimeString;
    fleet_id: number;
    rating_id: number;
    file: string;
    file1: string;
    file2: string;
    file3: string;
    file4: string;
    file5: string;
    file6: string;
    file7: string;
    file8: string;
    file9: string;
    file10: string;
    fileCount: number;
    status_id: number;
    text: string;
    checklist_id: number;
    driver_id: number;
    driver_name: string;
    question_id: string;
    damageReportTaskCount : number;
    location:any;
}

export class Service {
    id: number;
    date_done: string; 
    time_done: string;
    time_string: TimeString;
    fleet_id: number;
    provider_id: number;
    file: string;
    service_description: string;
    receipt_no: string;
    driver_id: number;
    hours: number;
    fault: string;
    cost: number;
    note: string;
    mileage: string;
    klms_next_service: string;
}


export class Repair {
    id: number;
    date_done: string; 
    time_done: string;
    time_string: TimeString;
    fleet_id: number;
    incident_id: number;
    provider_id: number;
    fleet_report_id: number
    file: string;
    repair_description: string;
    receipt_no: string;
    driver_id: number;
    mileage: number;
    hours: number;
    fault: string;
    cost: number;
    note: string;
    repair_request_id: number;
    repairPairing: any[];
}

export class RepairRequest {
    id: number;
    date_submitted: string; 
    time_submitted: string;
    time_string: TimeString;
    text: string;
    fleet_id: number;
    rating_id: number;
    status_id: number;
    repair_id: number
    driver_id: number;
    driver_name: string;
    checklist_id: number;
    question_id: number;
    filename: string;
    repairRequestTaskCount : number;
}

export interface TimeString {
    hour: number;
    minute: number;
}

export class RepairRequestChange {
    id: number;
    date_submitted: string; 
    time_submitted: string;
    time_string: TimeString;
    fleet_id: number;
    rating_id: number;
    status_id: number;
    repair_id: number
    driver_name: string;
    checklist_id: number;
    question_id: number;
    filename: string;
    repairRequestTaskCount : number;
    notes:string;
    repairRequestPairing: any[];
}

export class CancelPairing{
    cancelPairing: any[];
}
